/**
 * Потолок ожидания. Один зависший запрос не имеет права держать весь экран пустым —
 * по истечении показываем что есть, дальше блоки досыпают свои скелетоны сами.
 */
export const SCREEN_LOAD_TIMEOUT_MS = 4000
